import { ModuleBackgroundColor } from '@/types/amplience';

export const getModuleBackgroundStyles = (
  backgroundColor: string = 'white',
  grayClass: string = 'bg-gray-100/50'
) => {
  const bgClasses: Record<ModuleBackgroundColor, string> = {
    white: 'bg-white',
    gray: grayClass,
    black: 'bg-black',
  };

  const normalized = (backgroundColor.toLowerCase() || 'white') as ModuleBackgroundColor;
  const isBackgroundBlack = normalized === 'black';
  const textColor: 'text-white' | 'text-black' = isBackgroundBlack ? 'text-white' : 'text-black';

  return {
    bgClass: bgClasses[normalized] ?? bgClasses.white,
    textColor,
    isBackgroundBlack,
  };
};
